import {match} from 'ts-pattern';

import {createElement, ReactNode} from 'react';

import type {OAuthProviders, SmtpEmailProviderCode, UserMailboxProvider} from '@dms/api/core';

import customSmtpLogo from '../assets/custom-smtp-logo.svg';
import gmailLogo from '../assets/gmail-logo.svg';
import microsoftLogo from '../assets/microsoft-logo.svg';
import outlookLogo from '../assets/outlook-logo.svg';
import seznamLogo from '../assets/seznam-logo.svg';

export const getSmtpProviderLogo = (
  code: SmtpEmailProviderCode | OAuthProviders | UserMailboxProvider
): ReactNode => {
  const LogoComponent = match(code)
    .with('gmail-smtp', 'google', () => gmailLogo)
    .with('outlook-smtp', () => outlookLogo)
    .with('seznam-smtp', () => seznamLogo)
    .with('custom-smtp', 'imap', () => customSmtpLogo)
    .with('microsoft-oauth', 'microsoft', () => microsoftLogo)
    .otherwise(() => customSmtpLogo);

  return createElement(LogoComponent);
};
